module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.reviews) ? _c('ReviewsBlock', {
    attrs: {
      "reviews": _vm.reviews,
      "review-success": _vm.reviewPopup,
      "review-error": _vm.reviewError,
      "userData": _vm.userData,
      "auth": _vm.isAuthorized
    },
    on: {
      "submitReview": _vm.submitReview,
      "closePopup": _vm.closePopup
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51bbcdcb","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/reviews/component.vue
// module id = 61936ca5d82dad8b6d62
// module chunks = 1